import { render, staticRenderFns } from "./description-modal.vue?vue&type=template&id=f0187c7a&scoped=true&"
import script from "./description-modal.vue?vue&type=script&lang=js&"
export * from "./description-modal.vue?vue&type=script&lang=js&"
import style0 from "./description-modal.vue?vue&type=style&index=0&id=f0187c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0187c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0187c7a')) {
      api.createRecord('f0187c7a', component.options)
    } else {
      api.reload('f0187c7a', component.options)
    }
    module.hot.accept("./description-modal.vue?vue&type=template&id=f0187c7a&scoped=true&", function () {
      api.rerender('f0187c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/description-modal.vue"
export default component.exports